import React, {FC, useRef} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'components/Button';
import {getRecentBooking} from 'components/ContentPagesComponents/TextHeader';
import {useAppointments} from 'components/ContentPagesComponents/TextHeader/query';
import {Appointment} from 'components/ContentPagesComponents/TextHeader/query';

import {calendarOptions} from './calendarOptions';

import * as styles from './styles.module.scss';

type AddToCalendarProps = {
	onHide: () => void;
}

export const AddToCalendarModal: FC<AddToCalendarProps> = ({onHide}) => {
	const {data} = useAppointments();
	const ref = useRef<HTMLAnchorElement>(null);

	let recentBooking: Appointment | undefined;
	if (data?.auth.user?.appts) {
		recentBooking = getRecentBooking(data?.auth.user?.appts);
	}

	return (
		<Modal scrollable dialogClassName={styles.modal} size='sm' show onHide={onHide}>
			<Modal.Header closeButton className={styles.header}>
				<h2>Add to calendar</h2>
			</Modal.Header>
			<Modal.Body className={styles.body}>
				<div className={styles.options}>
					{calendarOptions.map((source, index) => (
						<Button key={index}
							variant='outline'
							onClick={() => {
								onHide();
								source.onClick(recentBooking, ref);
							}}
							className={styles.button}>
							{source.icon}
							{source.text}
						</Button>
					))}
					<a className={styles.hidden} ref={ref} />
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default AddToCalendarModal;

